import { MembersSearchParams } from '@libs/src/accounts/members.interfaces';
import { Account } from '@libs/src/models/account.model';
import {
  ACTION_QUEUE_STATUS_CANCELLED,
  ACTION_QUEUE_STATUS_COMPLETED,
  ACTION_QUEUE_STATUS_ERROR,
  ACTION_QUEUE_STATUS_IN_PROGRESS,
  ActionQueue,
  IMPORT_HISTORY_STATUS_INCOMPLETE,
} from '@libs/src/models/action-queue.model';
import { Group } from '@libs/src/models/group.model';

import get from 'lodash-es/get';

export function buildSearchParams(
  group: Group,
  isAdminMode: boolean,
  queryParams: { group?: string } = {},
  user: Account,
): MembersSearchParams {
  const groupId = get(group, '_id');
  if (groupId) {
    return {
      ...queryParams,
      group: groupId,
    };
  }

  if (isAdminMode && user.isAdmin) {
    return queryParams;
  }

  return {
    ...queryParams,
    group: user.groups[0].document._id,
  };
}

export const interests = 'interests';

export interface ActionQueueFile {
  account: { full_name: Account['full_name'] };
  created_at: Date;
  file_url: string;
  flat_file_generation: ActionQueue['flat_file_generation'];
  flat_file_name: ActionQueue['flat_file_name'];
  group: Pick<Group, '_id' | 'name' | 'slug'>;
  queues?: ActionQueue[];
  status?:
    | typeof ACTION_QUEUE_STATUS_CANCELLED
    | typeof ACTION_QUEUE_STATUS_COMPLETED
    | typeof ACTION_QUEUE_STATUS_ERROR
    | typeof ACTION_QUEUE_STATUS_IN_PROGRESS
    | typeof IMPORT_HISTORY_STATUS_INCOMPLETE;
  updated_at: Date;
}
